export enum StateEnum {
  breadcrumb = "breadcrumb",
  loginAsProfile = "loginasprofile"
}
